/**
 * PageHeader - Consistent page header with title and description
 *
 * Usage:
 * <PageHeader
 *   title="Dashboard"
 *   description="Monitor your key metrics and performance."
 * />
 */

export interface PageHeaderProps {
  title: string;
  /** @deprecated Use `description` instead */
  subtitle?: string;
  description?: string;
  children?: React.ReactNode;
}

export function PageHeader({ title, description, subtitle, children }: PageHeaderProps) {
  const text = description || subtitle;
  return (
    <div className="space-y-4 w-full">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-4xl font-bold tracking-tight">
            {title}
          </h1>
          {text && (
            <p className="text-muted-foreground mt-1.5 text-base">
              {text}
            </p>
          )}
        </div>
        {children && (
          <div className="flex items-center gap-2">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
